import React from "react";
import { useOutletContext } from "react-router-dom";
import Settings from "../../components/Company/Settings/Settings";

const CompanySettings = () => {
  const { page, setIsLoading, setPage, setIsModalOpen } = useOutletContext();

  return (
    <Settings
      page={page} 
      setIsLoading={setIsLoading} 
      setPage={setPage} 
      setIsModalOpen={setIsModalOpen}
    />
  );
};

export default CompanySettings;